// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"133":"da1f0e2f","344":"9d0463e8","488":"cb8156e0","492":"49c2b0be","587":"908cd63c","640":"d6d75190","727":"c632141f","771":"1921e0db"}[chunkId] + ".chunk.js";
};